export var LOGIN_TIMEOUT = 300000;
export var VIDEO_QQ_TICKET_PREFIX = 'vqq_';